import { render, staticRenderFns } from "./levelTab.vue?vue&type=template&id=d8deb93c&scoped=true&"
import script from "./levelTab.js?vue&type=script&lang=js&"
export * from "./levelTab.js?vue&type=script&lang=js&"
import style0 from "./levelTab.css?vue&type=style&index=0&id=d8deb93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8deb93c",
  null
  
)

export default component.exports